import { ISiteLoginParams } from '../types/ISiteLoginParams';
import { IGetSessionInfoResult } from './GetSessionInfoRequest';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class ClientCertificateLoginRequest extends Request<ISiteLoginParams, IGetSessionInfoResult> {
  constructor(params: ISiteLoginParams) {
    super('auth/clientCertificateLogin', params);
  }
}
